import React from 'react';
import { Box, Button } from '@mui/material';

interface DialogActionButtonsProps {
  onCancel: () => void;
  onSubmit: () => void;
}

export const DialogActionButtons: React.FC<DialogActionButtonsProps> = ({
  onCancel,
  onSubmit,
}) => (
  <Box sx={{ display: 'flex', justifyContent: 'flex-end', width: '100%', gap: 1 }}>
    <Button
      onClick={onCancel}
      sx={{ color: '#64748b' }}
    >
      Cancel
    </Button>
    <Button
      onClick={onSubmit}
      variant="contained"
      sx={{
        backgroundColor: '#162346',
        '&:hover': { backgroundColor: '#1a2a52' },
        fontWeight: 600,
      }}
    >
      Add Insurance
    </Button>
  </Box>
);
